"use client";

import {
  type ReactElement,
  type ReactNode,
  createContext,
  useContext,
} from "react";
import type { NativeAppKind } from "./native-app-agent";

const NativeAppKindContext = createContext<NativeAppKind | null>(null);

/** Root layout passes the middleware's verdict so SSR and client agree. */
export function NativeAppKindProvider({
  kind,
  children,
}: {
  readonly kind: NativeAppKind | null;
  readonly children: ReactNode;
}): ReactElement {
  return (
    <NativeAppKindContext.Provider value={kind}>
      {children}
    </NativeAppKindContext.Provider>
  );
}

/** "staff" / "portal" inside a store app, null in any browser. */
export function useNativeAppKind(): NativeAppKind | null {
  return useContext(NativeAppKindContext);
}
